export function extractJson(text) {
  if (!text) {
    throw new Error('Empty response from model');
  }

  const trimmed = text.trim();

  // 1. 直接解析
  try {
    return JSON.parse(trimmed);
  } catch {
    // continue
  }

  // 2. 提取 markdown 代码块
  const codeBlockMatch = trimmed.match(/```(?:json)?\s*([\s\S]*?)```/);
  if (codeBlockMatch) {
    try {
      return JSON.parse(codeBlockMatch[1].trim());
    } catch {
      // continue
    }
  }

  // 3. 提取第一个 JSON-like 对象或数组
  const jsonLikeMatch = trimmed.match(/(\{[\s\S]*\}|\[[\s\S]*\])/);
  if (jsonLikeMatch) {
    try {
      return JSON.parse(jsonLikeMatch[1].trim());
    } catch {
      // continue
    }
  }

  throw new Error(`Failed to parse JSON from response: ${trimmed.slice(0, 200)}`);
}
